import React from "react";
import RfpViewSwitch from "./RfpViewSwitch";

/** Primary analysis/review navigation for the RFP process pane. */
export default function RfpProcessHeader({
  jobView,
  onJobViewChange,
  scopeAnalysisAvailable,
  showViewSwitch = false,
}) {
  return (
    <div className="mb-3" data-testid="rfp-process-header">
      {showViewSwitch ? (
        <div data-testid="rfp-view-switch-slot">
          <RfpViewSwitch
            value={jobView}
            onChange={onJobViewChange}
            scopeAnalysisAvailable={scopeAnalysisAvailable}
          />
        </div>
      ) : null}
    </div>
  );
}
